import { render } from "./ResourcePills.vue?vue&type=template&id=3a5f54ae"
import script from "./ResourcePills.vue?vue&type=script&lang=js"
export * from "./ResourcePills.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__